/**
 * InfoBanner Component
 */

import React from "react";
import { Icon } from "rhombus-react";

import "./InfoBanner.css";

export default function InfoBanner({ children, icon, error, warning }){
	let showIcon = icon
		, errorMessage = ''
		, errorClass = ""
		, shouldShowChildren = !error && !warning
		;

	if(error){
		errorClass = "has-error";
		showIcon = "errorT";
		errorMessage = error.description || "There was a problem!";
	} else if (warning) {
		errorClass = "has-warning";
		showIcon = "errorT";
		errorMessage = (
			<span>
				<strong>Warning!</strong> {warning.description || "There was a problem!"}
			</span>
		);
	}

	return (
		<div className={`info-banner-container ${errorClass}`}>
			<Icon name={showIcon} />
			<span className="message">
				{shouldShowChildren && children}
				{!shouldShowChildren && errorMessage}
			</span>
		</div>
	);
}

InfoBanner.displayName = InfoBanner;
InfoBanner.defaultProps = {
	error:null,
	icon:"infoC",
	children: null,
};
